var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventTracking({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-park-outline:upload-logs"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.3039 17.3047H7.10391C6.94478 17.3047 6.79216 17.2415 6.67964 17.129C6.56712 17.0164 6.50391 16.8638 6.50391 16.7047V5.90469C6.50391 5.74556 6.56712 5.59295 6.67964 5.48042C6.79216 5.3679 6.94478 5.30469 7.10391 5.30469H15.5039C15.663 5.30469 15.8156 5.3679 15.9282 5.48042C16.0407 5.59295 16.1039 5.74556 16.1039 5.90469V11.3047M14.7539 17.3047V13.4047",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.4043 14.4555L13.8543 14.0055L14.7543 13.1055L15.6543 14.0055L16.1043 14.4555",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.9043 8.90625H13.7043M8.9043 11.3063H11.3043",
    stroke: "white",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventTracking);
export default __webpack_public_path__ + "static/media/event-tracking.88c53f053c2823ea7dbfa03e8d802bf3.svg";
export { ForwardRef as ReactComponent };